import { memo } from 'react'
import type { Lease, VmMetrics } from '@/api/types'
import { TableCell, TableRow } from '@/components/ui/table'
import { IoLine } from '@/components/IoLine'
import { ToneBadge } from '@/components/ToneBadge'
import { AllocationCell, UsageCell } from '@/components/UsageCell'
import { diskAllocatedGb, leaseToneOf, leaseWord } from '@/domain/lease'
import { gib } from '@/ui/format'
import { VmTags } from '../vm/VmTags'

// 내 VM 목록(`MyVms.tsx`)의 한 줄. 관리자 목록의 줄(`views/vm/VmRow.tsx`)과 같은 꼴이다 — `memo` 라 받은 것이 모두
// 이전과 같으면 다시 그리지 않고, 받는 것은 응답의 객체(임대·지금 읽기)와 고정된 콜백뿐이다.

type Props = {
  lease: Lease
  /** 지금 읽기. 활성 임대가 아니거나 아직 읽지 못했으면 없다. */
  m: VmMetrics | undefined
  onOpen: (leaseId: string) => void
}

export const MyVmRow = memo(function MyVmRow({ lease: l, m, onOpen }: Props) {
  return (
    <TableRow onClick={() => onOpen(l.id)} className="cursor-pointer hover:bg-surface-2">
      <TableCell className="font-medium max-sm:col-span-2 max-sm:truncate">
        {l.name}
        <VmTags tags={l.tags} className="mt-0.5 flex" />
      </TableCell>
      <TableCell>
        <UsageCell label="CPU" used={m?.cpu == null ? null : m.cpu * l.cores} total={l.cores} unit="코어" color="var(--chart-1)" />
      </TableCell>
      <TableCell>
        <UsageCell label="메모리" used={gib(m?.memory_used_mb)} total={gib(m?.memory_total_mb)} unit="size" color="var(--chart-2)" />
      </TableCell>
      <TableCell>
        <AllocationCell gb={diskAllocatedGb(l)} />
      </TableCell>
      <TableCell>
        <IoLine metrics={m} kind="net" />
      </TableCell>
      <TableCell>
        <IoLine metrics={m} kind="disk" />
      </TableCell>
      <TableCell className="max-sm:col-start-3 max-sm:row-start-1 max-sm:justify-self-end">
        <ToneBadge tone={leaseToneOf(l.state)}>{leaseWord(l.state)}</ToneBadge>
      </TableCell>
    </TableRow>
  )
})
